export const About: React.FC = () => {
  return (
    <section className="section sec2 about active" id="about">
      <div className="about__container__title">
        <h2>
          "About" <span>me</span>
          <span className="background__text">My states</span>
        </h2>
      </div>
    </section>
  );
};
